import { authRoles } from "./auth/authRoles";
import HomeWorkIcon from '@mui/icons-material/HomeWork';

export const navigations = [
  { name: 'Anasayfa', path: '/dashboard/default', icon: 'home', auth: authRoles.Teacher },
  //{ label: 'Kategoriler', type: 'label' },
  {
    name: 'Bayilik',
    icon: 'group',
    children: [
      { name: 'Yeni Bayilik', iconText: 'YB', path: '/dealership/new', auth: authRoles.Admin },
      { name: 'Bayiler', iconText: 'B', path: '/dealership/dealerships', auth: authRoles.Dealer },
    ],
    auth: authRoles.Dealer
  },
  { name: 'Kurumlar', path: '/corporation/corporations', icon: <HomeWorkIcon fontSize="small"/>, auth: authRoles.Teacher },
  { name: 'Öğretmenler', path: '/teacher/teachers', icon: 'people_outline', auth: authRoles.Teacher },
  { name: 'Bilgisayarlar', path: '/computer/computers', icon: 'computer', auth: authRoles.Teacher },
  //--
  //{ name: 'Harita', path: '/map/default', icon: 'map', auth: authRoles.Admin },
  // { label: 'PAGES', type: 'label' },
  // {
  //   name: 'Session/Auth',
  //   icon: 'security',
  //   children: [
  //     { name: 'Sign in', iconText: 'SI', path: '/session/signin' },
  //     { name: 'Sign up', iconText: 'SU', path: '/session/signup' },
  //     { name: 'Forgot Password', iconText: 'FP', path: '/session/forgot-password' },
  //     { name: 'Error', iconText: '404', path: '/session/404' },
  //   ],
  // },
  // { label: 'Components', type: 'label' },
  // {
  //   name: 'Components',
  //   icon: 'favorite',
  //   badge: { value: '30+', color: 'secondary' },
  //   children: [
  //     { name: 'Auto Complete', path: '/material/autocomplete', iconText: 'A' },
  //     { name: 'Buttons', path: '/material/buttons', iconText: 'B' },
  //     { name: 'Checkbox', path: '/material/checkbox', iconText: 'C' },
  //     { name: 'Dialog', path: '/material/dialog', iconText: 'D' },
  //     { name: 'Expansion Panel', path: '/material/expansion-panel', iconText: 'E' },
  //     { name: 'Form', path: '/material/form', iconText: 'F' },
  //     { name: 'Icons', path: '/material/icons', iconText: 'I' },
  //     { name: 'Menu', path: '/material/menu', iconText: 'M' },
  //     { name: 'Progress', path: '/material/progress', iconText: 'P' },
  //     { name: 'Radio', path: '/material/radio', iconText: 'R' },
  //     { name: 'Switch', path: '/material/switch', iconText: 'S' },
  //     { name: 'Slider', path: '/material/slider', iconText: 'S' },
  //     { name: 'Snackbar', path: '/material/snackbar', iconText: 'S' },
  //     { name: 'Table', path: '/material/table', iconText: 'T' },
  //   ],
  // },
  // {
  //   name: 'Charts',
  //   icon: 'trending_up',
  //   children: [{ name: 'Echarts', path: '/charts/echarts', iconText: 'E' }],
  // },
  // {
  //   name: 'Documentation',
  //   icon: 'launch',
  //   type: 'extLink',
  //   path: 'http://demos.ui-lib.com/matx-react-doc/',
  // },
];
